export default "__VITE_ASSET__Cc8RoS7X__"